import { GAME_TITLE } from '../../constants/strings'

type Props = {
  title: string,
  body: JSX.Element
}
export const LegalTemplate = ({title, body}: Props) => {
  return <div className="px-1 pb-8 md:max-w-7xl w-full mx-auto sm:px-6 lg:px-8 flex flex-col grow dark:text-white">
    <a href="/" className="text-center text-xl font-bold title dark:text-white mt-8">
      {GAME_TITLE}
    </a>
    <p className="title text-3xl"><strong>{title}</strong></p>
    {body}
  </div>
}
